import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useModal } from 'hooks';
import {
  AssignSpeakers as AssignSpeakersForm,
  ASSIGN_SPEAKERS,
} from '@shoflo/polymer';
import { sendToDatadog } from '@studio/logger';
import { Modal, ModalBody } from 'reactstrap';
import { updateSource } from 'actions/source';
import { getHostSources, getSpeakerSources } from './utils';
import { reduceSourceForLogs } from '@studio/sources';

function AssignSpeakers() {
  const dispatch = useDispatch();
  const { isOpen, initialValue: pdfSource, clear } = useModal(ASSIGN_SPEAKERS);
  const sources = useSelector((state) => state.broadcastSources.sources);

  const speakerSources = getSpeakerSources(sources);
  const hostSources = getHostSources(sources);

  const loggerName = 'presentation-control';

  useEffect(() => {
    const hostSourcesData = reduceSourceForLogs(hostSources);
    const speakerSourcesData = reduceSourceForLogs(speakerSources);
    const presentation = {
      hostSourcesData,
      speakerSourcesData,
      source: pdfSource,
    };
    if (isOpen) {
      sendToDatadog(
        loggerName,
        { presentation },
        'Presentation Control - Host - Assign speakers modal opened',
        false
      );
    }
  }, [isOpen, hostSources, speakerSources]);

  if (!pdfSource) {
    return;
  }

  const previouslySelectedSpeakers = pdfSource.value?.speakerUserIds ?? [];

  function onSave(selectedSpeakerIds) {
    const { value, _id: id } = pdfSource;
    value.speakerUserIds = selectedSpeakerIds;
    dispatch(updateSource(id, { value }, { showPdfNotification: true }));
    const assignedUsersSource = selectedSpeakerIds.map((source) =>
      sources.find((s) => s.user === source)
    );
    const presentation = {
      source: pdfSource,
      assignedUsersSource,
      selectedSpeakerIds,
    };
    sendToDatadog(
      loggerName,
      { presentation },
      'Presentation Control - Host - Speaker assigned to presentation',
      false
    );
    clear();
  }

  return (
    <Modal isOpen={isOpen} toggle={clear}>
      <ModalBody className="p-4">
        <AssignSpeakersForm
          hostSources={hostSources}
          speakerSources={speakerSources}
          onSave={onSave}
          onCancel={clear}
          previouslySelectedSpeakers={previouslySelectedSpeakers}
        />
      </ModalBody>
    </Modal>
  );
}

export default AssignSpeakers;
